import React, { useEffect, useState } from 'react';
interface PriceDisplayProps {
  amountARS: number;
  className?: string;
  strikeThrough?: boolean;
}
export const PriceDisplay: React.FC<PriceDisplayProps> = ({
  amountARS,
  className = '',
  strikeThrough = false
}) => {
  const [display, setDisplay] = useState({
    symbol: '$',
    amount: amountARS,
    currency: 'ARS'
  });
  useEffect(() => {
    const lang = navigator.language.toLowerCase();
    let symbol = '$';
    let rate = 1;
    let currency = 'ARS';
    if (lang.startsWith('es-ar')) {
      symbol = '$';
      rate = 1;
      currency = 'ARS';
    } else if (lang.startsWith('es-mx')) {
      symbol = '$';
      rate = 0.02;
      currency = 'MXN';
    } else if (lang.startsWith('es-cl')) {
      symbol = '$';
      rate = 1.1;
      currency = 'CLP';
    } else if (lang.startsWith('es-es') || lang.startsWith('fr') || lang.startsWith('de') || lang.startsWith('it')) {
      symbol = '€';
      rate = 0.0011;
      currency = 'EUR';
    } else if (lang.startsWith('en-gb')) {
      symbol = '£';
      rate = 0.0009;
      currency = 'GBP';
    } else if (lang.startsWith('en')) {
      symbol = 'US$';
      rate = 0.0012;
      currency = 'USD';
    }
    setDisplay({
      symbol,
      amount: Math.round(amountARS * rate),
      currency
    });
  }, [amountARS]);
  return <span className={`${className} ${strikeThrough ? 'line-through opacity-60' : ''}`} data-id="element-166">
      {display.symbol}
      {display.amount.toLocaleString('es-AR')} {display.currency}
    </span>;
};